<div class="productAdd seedAddProduct">
  <h3>Add Product(s) to the order</h3>
  <div class="form-sec">
    <div class="row margin-r0">
      <div class="col-md-10 col-lg-11 smallPadRgt0">
        <div class="row search-box-outer">
          <div class="col-4 col-md-3 padding-r0 border-right padding-l0">

            <!--<div class="brand-dropdown material-select">
              <ng-select [items]="searchTypeList"
                         name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         bindValue="value"
                         labelForId="name"
                         [searchable]="false"
                         (change)="keepFilter()">
              </ng-select>
            </div>-->
            <div class="brand-dropdown material-select d-none d-md-block">
              <ng-select name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         [searchable]="false"
                         labelForId="name"
                         (change)="keepFilter()"
                         data-testid="ddl-itemNumber-search">
                <ng-option *ngFor="let data of searchTypeList;let index=index" [value]="data">
                  <span [attr.data-testid]="'ddl-search-select_'+index">{{data}}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="brand-dropdown material-select d-block d-md-none">
              <ng-select name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         [searchable]="false"
                         labelForId="name"
                         (change)="keepFilter()"
                         data-testid="ddl-itemNumber-search">
                <ng-option *ngFor="let data of searchTypeListMobile;let index=index" [value]="data">
                  <span [attr.data-testid]="'ddl-search-select_'+index">{{data}}</span>
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-8 col-md-9 padding-l0 padding-r0">
            <div class="material-select sales-search">
              <!--<ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Product Name'"
                         [items]="productMasterList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [(ngModel)]="productFilters.Brand"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (search)="partialSearch($event)"
                         (keyup.enter)="selectProductName($event)"
                         (change)="selectProductName($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>-->

              <ng-select #itemNumber name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                         [items]="itemNumberList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ItemNoList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div #productSearch *ngIf="selectedValue === 'Product Name'">
                <div class="search-box-outer">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateProductSearch()"
                             placeholder="Search Product" type="text">
                    </div>
                  </div>
                </div>
              </div>
              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Marketing Brand' || selectedValue ==='Manufacturer'"
                         [items]="marketingMasterList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.MarketingBrandList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                         [items]="seedsizeMasterList"
                         placeholder="Search Product"
                         [multiple]="true"
                         [hideSelected]="true"
                         class="custom-select-grower"
                         [(ngModel)]="productFilters.SeedSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                         [items]="packagesizeMasterList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.PackageSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div #productSearch *ngIf="selectedValue === 'Technology'">
                <div class="search-box-outer">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.TechnologyList" (ngModelChange)="validateTechnologySearch()"
                             placeholder="Search Technology" type="text">
                    </div>
                  </div>
                </div>
              </div>
              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Treatment'"
                         [items]="treatmentMasterList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.TreatmentList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                         [items]="productLineMasterList"
                         placeholder="Search Product"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ProductLineList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p>
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Maturity'">
                <ng-select #productSearch name="ddlproductSearch"
                           [items]="maturityMasterList"
                           placeholder="Min"
                           class="custom-select-grower "
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.MaturityMin"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Maturity'">
                <ng-select #productSearch name="ddlproductSearch"
                           [items]="maturityMasterList"
                           placeholder="Max"
                           class="custom-select-grower"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.MaturityMax"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter()">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p>
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--filter list mobile starts-->
      <div class="col-sm-12 selected-chip d-sm-block d-md-none padding-l20 padding-t10">
        <div class="row">
          <div class="col-9">
            <div>
              <mat-chip-set>
                <mat-chip selected *ngFor="let filterValue of filterValueList">
                  {{filterValue}}
                  <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                    <i class="fas fa-times text-right"></i>
                  </a>
                </mat-chip>
              </mat-chip-set>
            </div>
          </div>
          <div class="col-3 text-right" *ngIf="filterValueList.length > 0">
            <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
          </div>
        </div>
      </div>
      <!--filter list mobile ends-->

      <div class="col-md-2 col-lg-1 col-sm-12 search-btn-outer text-center padding-sm-l15 padding-sm-r0">
        <div class="search-btn">
          <button mat-raised-button class="btns wide-sm-100 margin-t12 margin-sm-t10" color="primary" (click)="keepFilter();getProducts()" [disabled]="isTextBoxEmpty" data-testid="btn-orderfilter-search">Search</button>
        </div>
      </div>
    </div>
    <div class="d-flex showProdSec justify-content-end xs-p-10 row">

      <div *ngIf="page == 'growerOrder'" class="col-6 col-md-3">
        <div class="row">
          <div class="col-9 m-auto">Only show product on Dealer Order</div>
          <mat-checkbox class="custom-checkbox col-3" #chkDealerOrderAvailability (change)="checkDealerOrderAvailability(chkDealerOrderAvailability._checked)" [(ngModel)]="enableDealerCheckBox"></mat-checkbox>
        </div>
      </div>

      <div class="xs-pl-20 col-6 col-md-3">
        <div class="row">
          <div class="col-9 m-auto">Only show product with availability</div>
          <mat-checkbox class="custom-checkbox col-3" #chkAvailability (change)="checkAvailability(chkAvailability._checked)" [(ngModel)]="enable"></mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row selected-chip d-none d-md-flex">
      <div class="col-md-9 ">
        <div>
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList">
              {{filterValue}}
              <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="col-md-3 text-right padding-r20" *ngIf="filterValueList.length > 0">
        <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="tableContainer table-mobile-landing">
        <table mat-table #productsTable [dataSource]="productDataSource" matSort #itemSort="matSort" matSortDirection="desc" (matSortChange)="sortData($event)"  class="matTables">
          <!-- Position Column -->
          <ng-container matColumnDef="SeedAvailability">
            <th mat-header-cell mat-sort-header *matHeaderCellDef  class="text-center" title="Availability">Avail.</th>
            <td mat-cell *matCellDef="let element" class="available-block text-center">
              <div class="mobileText">Avail.</div>
              <span class="seed-avail">
                {{element.seedAvailability | number}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="NetBEU">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center" title="Dealer Order">DO</th>
            <td mat-cell *matCellDef="let element" class="available-block text-center">
              <div class="mobileText">DO</div>
              <span class="seed-avail">
                {{element.netBEU | number}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="DealerBucket">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center" title="My Dealer Bucket"> MDB </th>
            <td mat-cell *matCellDef="let element" class="available-block text-center">
              <div class="mobileText">MDB</div>
              <span *ngIf="page !== 'growerOrder'">
                <span class="seed-avail" *ngIf="element.myDealerBucket>=0">{{element.myDealerBucket | number}}</span>
                <span class="seed-avail" *ngIf="element.myDealerBucket<0">({{element.myDealerBucket | positiveValue | number}})</span>
              </span>
              <span *ngIf="page === 'growerOrder'">
                <span class="seed-avail" *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                <span class="seed-avail" *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
              </span>
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="Product Name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="productNameBlock">Product Name </th>
            <td mat-cell *matCellDef="let element" class="order-info d-sm-block d-md-table-cell product-line" id="td-ProductDetail" [attr.data-testid]="element.itemNumber">
              <p class="d-block d-md-none padding-l5">Product</p>
              <p><a>{{element.brand}} - {{element.marketingBrand}}</a> </p>
              <p class="grower-name">
                <a>
                  {{element.itemDescription}}
                </a>
              </p>
              <p *ngIf="element.seedNonReturnable" class="nonReturnable"> <a>*NON-RETURNABLE </a></p>
              <div class="checkBoxOuterBg margin-t10 d-md-none">
                <div class="chkboxOuter">
                  <i class="fas fa-check checkShowHide"></i>
                  <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && (element.isProductDeactivated == false || (element.deactivationType == null || page == 'dealerOrder' || element.deactivationType.trim().toLowerCase() != 'suspend'))"></mat-checkbox>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="Pack Size">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Pack Size </th>
            <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
              <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                {{element.packageSize}}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Seed Size">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Seed Size </th>
            <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell"> {{element.seedSize}} </td>
          </ng-container>

          <ng-container matColumnDef="Technology">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Technology </th>
            <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
              <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                {{element.technology}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="Treatment">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Treatment </th>
            <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
              <span class="oval-shape" [ngClass]="{'treatment': (element.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                {{element.treatment}}
              </span>
            </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="Maturity">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Maturity </th>
            <td mat-cell *matCellDef="let element; let i=index" class="text-center d-none d-md-table-cell" [attr.data-testid]="'ddl-maturity-check_'+i"> {{element.maturity}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="Product Line">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Product Line </th>
            <td mat-cell *matCellDef="let element" class="product-line text-center d-none d-md-table-cell">
              <div class="checkBoxOuterBg">
                <div class="chkboxOuter">
                  <i class="fas fa-check checkShowHide"></i>
                  <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && (element.isProductDeactivated == false || (element.deactivationType == null || page == 'dealerOrder' || element.deactivationType.trim().toLowerCase() != 'suspend'))"></mat-checkbox>
                </div>
              </div>
              <span>
                {{element.productLine}}
              </span>
              <div class="unavailableMsg" *ngIf="element.isProductDeactivated === true && (element.deactivationType == null || page == 'dealerOrder' || element.deactivationType.trim().toLowerCase() == 'suspend')">
                <div id="main_{{element.itemNumber}}">
                  <div class="unavail-content" id="sub_{{element.itemNumber}}">
                    <h4>This item is currently unavailable for ordering.</h4>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'active':row.IsProductSelected}" (click)="keepRecords(row)"></tr>
        </table>
        <!--<mat-paginator #productPaginator [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>-->
      </div>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-12 col-md-6 padding-l25">
      <button mat-raised-button class="btns wide-sm-100 w180 font-sm-14" color="primary" [disabled]="isProductNotAdded" (click)="AddProducts()" id="btn-add-to-order">Add to Order</button>
    </div>
    <div class="col-md-6 text-right d-none d-md-block">
      <span class="count">{{selectedProductList.length}} selected</span>
    </div>
    <!--<div class="col-md-2 text-right">
      &nbsp;
    </div>-->
  </div>
</div>
